import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
export default function Employers() {
  return <section id="employers" className="dark bg-background text-foreground py-20 px-6 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {}
        <div className="relative w-full aspect-square md:aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
          <img src="https://frank-crawfish.10web.cloud/wp-content/uploads/2026/03/qtq80-XPoaFo-dfa6eac7-1.jpeg" alt="Employer managing candidates" className="w-full h-full object-cover" />
        </div>

        {}
        <Card className="bg-primary text-primary-foreground border-none rounded-2xl p-8 md:p-12 shadow-xl">
          <CardContent className="p-0 flex flex-col gap-6 items-start">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">
              Employers
            </h2>
            <p className="text-lg md:text-xl text-primary-foreground/90 leading-relaxed max-w-md">
              Access your subscription to manage job postings and candidates
            </p>
            <Button asChild className="bg-background text-foreground hover:bg-background/90 rounded-full px-8 py-6 text-base font-semibold mt-4 shadow-md transition-transform hover:scale-105">
              <Link to="#">
                Account Login
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </section>;
}